import React from "react"
import { connect } from "react-redux"
import { get, map } from "lodash"

import {
  addRegisterSymbolSheet,
  changeRegisterSheet,
  RegisterSymbolStateType,
} from "redux/ducks/RegisterSymbol"
import store from "redux/store"
import { APIResponse } from "redux/apis/types"
import { BaseSelect } from "components/atoms/input/select"

type FavoriteModalPropsType = {
  onHide: Function
  symbol?: APIResponse.Res
}

export const FavoriteModal = connect(
  (state: { registerSymbol: RegisterSymbolStateType }) => {
    return { registerSymbol: state.registerSymbol }
  }
)(
  (
    props: FavoriteModalPropsType & { registerSymbol?: RegisterSymbolStateType }
  ) => {
    const sheetList = map(
      props.registerSymbol.symbolSheetList.SheetList,
      (data: object, i: number) => {
        return { id: i, name: get(data, "SheetName") }
      }
    )
    return (
      <div className="favorite-contents">
        <BaseSelect
          option={sheetList}
          value={props.registerSymbol.symbolSheet.SheetNo}
          onChange={(id: number) =>
            store.dispatch(changeRegisterSheet(String(id)))
          }
        />
        <div
          className="btn btn-primary btn-shaped"
          onClick={() => {
            store.dispatch(
              addRegisterSymbolSheet(
                props.symbol,
                props.registerSymbol.symbolSheet
              )
            )
            props.onHide()
          }}
        >
          登録
        </div>
      </div>
    )
  }
)
